import { render } from "./edit-prescription1.vue?vue&type=template&id=5370a3cb"
import script from "./edit-prescription1.vue?vue&type=script&lang=js"
export * from "./edit-prescription1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__